import gql from 'graphql-tag';
import { DEAL_CALL_ACTIVITY_FRAGMENT } from 'modules/dealActivity/api/fragments/dealCallActivity.fragment';
import { DEAL_EMAIL_ACTIVITY_FRAGMENT } from 'modules/dealActivity/api/fragments/dealEmailActivity.fragment';
import { DEAL_NOTE_ACTIVITY_FRAGMENT } from 'modules/dealActivity/api/fragments/dealNoteActivity.fragment';

export const GET_CUSTOMER_DEAL_ACTIVITIES = gql`
  query CustomerDealActivities($input: CustomerDealActivitiesInput!) {
    customer {
      customerDealActivities(input: $input) {
        error
        success
        list {
          ...DealCallActivityFields
          ...DealNoteActivityFields
          ...DealEmailActivityFields
          __typename
        }
      }
    }
  }
  ${DEAL_CALL_ACTIVITY_FRAGMENT}
  ${DEAL_NOTE_ACTIVITY_FRAGMENT}
  ${DEAL_EMAIL_ACTIVITY_FRAGMENT}
`;
